<template>
  <div class="board-row">
    <div class="subscription-col">
      <div class="padding-div"> </div>
      <span class="board-name">{{board.boardName | decodeHtml}}</span>
    </div>
    <div class="subscription-col email-col">
      <div v-if="email">
      <div class="imidiate-email">
        <input type="checkbox" v-model="email.immediate" @change="toggleBoardImmediate">
        <span>Immediate</span>
      </div>
    </div>
    </div>
    <div class="subscription-col">
      <input type="checkbox" v-model="isSubscribed" @change="toggleBoardSubscription">
      <span>Immediate</span>
    </div>
  </div>
</template>

<script>
import api from '../../../api/api';

export default {
  props: ['board', 'emailSetting'],
  data() {
    return {
      boardName: '',
      boardId: null,
      isSubscribed: false,
      email: null,
    }
  },
  created() {
    this.boardName = this.board.boardName;
    this.boardId = this.board.boardID;
    this.isSubscribed = this.board.subscribed;
    this.email = this.emailSetting;
  },
  watch: {
    board(newValue) {
      this.$forceUpdate();
      this.boardName = newValue.boardName;
      this.boardId = newValue.boardID;
      this.isSubscribed = newValue.subscribed;
    },
    emailSetting: {
      handler(val) {
        this.email = val;
        this.$forceUpdate();
      },
      deep: true,
    }
  },
  methods: {
    toggleBoardImmediate() {
      api.post('/Communication/boards/'+this.board.boardID, {
        Immediate: this.email.immediate,
        Id: this.email.id,
      });
    },
    toggleBoardDaily() {
      api.post('/Communication/boards/'+this.board.boardID, {
        Daily: this.email.daily,
        Id: this.email.id,
      });
    },
    toggleBoardWeekly() {
      api.post('/Communication/boards/'+this.board.boardID, {
        Weekly: this.email.weekly,
        Id: this.email.id,
      });
    },
    toggleBoardSubscription() {
      if(this.isSubscribed === true) {
        api.post('/Subscription/boards', {
          BoardID: this.boardId,
        }).catch(() => {
          this.isSubscribed = !this.isSubscribed;
        });
      }
      else{
        api.delete('/Subscription/boards', {
          BoardID: this.boardId,
        }).catch(() => {
          this.isSubscribed = !this.isSubscribed;
        });
      }
      this.$emit('refreshcheck', {
        boardId: this.boardId,
        isSubscribed: this.isSubscribed
      });
    }
  }
}
</script>


<style scoped>
  .padding-div{
    min-width:40px;
    display: inline-block;
}
</style>